export const containsDigitsLowerCaseAndUpperCaseValidator = (password: string) => {
  const validator = /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])/;

  return validator.test(password);
};
